module.exports = __webpack_public_path__ + "img/Good Student Award 5.66d029a2.png";